var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-wrap",attrs:{"id":_vm.finalConfig.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }